import { render, staticRenderFns } from "./ResidentDetail.vue?vue&type=template&id=6fae7365"
import script from "./ResidentDetail.vue?vue&type=script&lang=js"
export * from "./ResidentDetail.vue?vue&type=script&lang=js"
import style0 from "./ResidentDetail.vue?vue&type=style&index=0&id=6fae7365&prod&media=screen&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports